<template>
  <v-expansion-panels :value="0">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <b>Варианты</b>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <BListFilter
          v-model="searchForm"
          label="Поиск..."
          :skeleton="isLoading"
          dense
          class="my-2"
          @change="onChangeDebounced"
        />
        <BTable
          :list="list"
          :headers="headers"
          :loading="isLoading"
          :pagination="pagination"
          @change:pagination="onChangePagination"
        >
          <template #item.vpr_original_variant_number="{ item }">
            <span class="mr-2">{{ item.vpr_original_variant_number }}</span>
            <BTableButtonAction
              v-if="!!item.variant_file_sha1"
              :action="actions.downloadVariant"
              :data="item"
              @action:download="(_, callback) => onDownload(item.variant_file_sha1, callback)"
            />
          </template>

          <template #item.vpr_original_variant_criteria_number="{ item }">
            <span class="mr-2">{{ item.vpr_original_variant_criteria_number }}</span>
            <BTableButtonAction
              v-if="!!item.variant_criteria_file_sha1"
              :action="actions.downloadCriteria"
              :data="item"
              @action:download="(_, callback) => onDownload(item.variant_criteria_file_sha1, callback)"
            />
          </template>
        </BTable>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import BTable from '@/components/common/BTable.vue'
import BListFilter from '@/components/forms/BListFilter.vue'
import BTableButtonAction from '@/components/common/BTable/BTableButtonAction.vue'

import { VPRVariantsApi } from '@/api/resources'
import { DOWNLOAD } from '@/helpers/enums/table-actions'
import { downloadLinkByGet } from '@/helpers/downloadBlob'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: 10,
  count: 0,
}


export default {
  name: 'VprVariantsTable',
  components: {
    BTable,
    BListFilter,
    BTableButtonAction,
  },
  props: {
    vprPublicationPartId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    actions: {
      downloadVariant: {
        ...DOWNLOAD,
        tooltip: 'Скачать вариант',
      },
      downloadCriteria: {
        ...DOWNLOAD,
        tooltip: 'Скачать критерии',
      },
    },

    isLoading: false,
    list: [],
    searchForm: {
      search: null,
    },
    pagination: { ...DEFAULT_PARAMS },
    headers: [
      {
        text: 'Часть',
        value: 'vpr_publication_part_position',
        sortable: false,
      },
      {
        text: 'Вариант',
        value: 'vpr_original_variant_number',
        sortable: false,
      },
      {
        text: 'Критерии',
        value: 'vpr_original_variant_criteria_number',
        sortable: false,
      },
      {
        text: 'Заданий с GUID',
        value: 'guid_tasks_count',
        sortable: false,
      },
    ],
  }),
  methods: {
    asyncData() {
      const params = { ...this.pagination }
      this.onGetData(params)
    },
    onRefresh() {
      this.searchForm.search = null
      this.pagination.page = 1
      this.onGetData()
    },
    async onGetData(params) {
      if (!this.vprPublicationPartId) {
        return
      }

      this.isLoading = true
      const api = new VPRVariantsApi()
      try {
        const payload = {
          ...this.pagination,
          ...params,
          vpr_publication_part_id: this.vprPublicationPartId,
        }
        if (this.searchForm.search) {
          payload.search = this.searchForm.search
        } else {
          delete payload.search
        }
        const result = await api.getAll(payload)
        this.list = result.data
        this.pagination.page = payload.page
        this.pagination.count = result.meta.count
        if (result.meta?.count > 0) {
          this.$emit('received')
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    onChangePagination(options) {
      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData()
    },
    onChangeDebounced() {
      this.onGetData({ page: 1 })
    },
    onDownload(sha1, callback) {
      const unwatch = callback?.()
      try {
        const path = `${process.env.VUE_APP_COLLECTOR_API_URL}/api/v1/files/${sha1}/download`
        downloadLinkByGet(
          path,
          false,
          { isNewTab: false },
          { headers: { 'X-Access-Token': process.env.VUE_APP_COLLECTOR_API_TOKEN } },
        )
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        unwatch?.()
      }
    },
  },
}
</script>
